// export const api_url = 'http://api.ydd.sxcvz.com/'  //测试
//export const api_url = 'https://api.yuduoduogongju.com/'  //正试
export const api_url = 'https://api.yuduoduogongju.com/'  //正试
// export const api_url = 'http://api.yuduoduogongju.local/'  //测试
export const up_api = ''
export const baseImageUrl = 'https://yuduoduo.oss-cn-hangzhou.aliyuncs.com/'


export function debounce(fn, delay = 200) {
    let timer
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            console.log('this', this)
            fn.apply(this, args)
        }, delay);
    }
}


export function checkPhone(phone){
   return /^1[3456789]\d{9}$/.test(phone)
}

export  function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

export function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}
// dateFormat("YYYY-mm-dd HH:MM", date)


/**
 * @function escapeHTML 转义html脚本 < > & " '
 * @param a -
 *            字符串
 */
export function escapeHTML(a){
    a = "" + a;
    return a.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
/**
 * @function unescapeHTML 还原html脚本 < > & " '
 * @param a -
 *            字符串
 */
export function unescapeHTML(a){
    a = "" + a;
    return a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'");
}




